// Valid email checker
export const cleanEmail = (val: string) => {
    return val.replaceAll(/[;<>\s]/g, '')
}
export const validEmail = (val: string) => {
    let testVal = cleanEmail(val)

    if (testVal.split('@').length !== 2) return false
    return /[a-zA-Z0-9.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+/.test(testVal)
}

// Valid phone checker
export const cleanPhone = (val: string) => {
    return val.replaceAll(/[-()\s]/g, '')
}
export const validPhone = (val: string) => {
    let testVal = cleanPhone(val)
    return /^[+]?\d{10,15}$/.test(testVal)
}
